import { Component, ChangeDetectorRef, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService, TestData } from '../services/authentication.service';
import { Router } from '@angular/router';
import { QuestionSetService, collegequestionset } from '../services/questionset.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { Overall_Result } from './overall_result.model';
import { CollegeService, College_Names } from '../services/College_name.service';
import { YearService } from '../services/year.service';
import { Schedule } from '../scheduletest/scheduletest.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSortModule, MatSort} from '@angular/material/sort';
import { report, ReportService } from '../services/report.service';

@Component({
  templateUrl: './overall_result.component.html',
  styleUrls: [ './overall_result.component.scss' ]
})

export class OverAllResultComponent implements OnInit {
  question_set:collegequestionset = {collegeid:'',yearid:''}
  displayedColumns: string[] = ['S.No.','First_Name','Total_Score','View'];
  report_details: report = {  College_Id: '', Year_Id: '',Question_Set:''};
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  searchKey: string;
  dataSource: MatTableDataSource<any>;
  fieldArray: Array<Schedule> = [];
  selectedCategory;
  selectedCategoryindex: string;
  newAttribute: any = {};
  Question_Category: any;
  result: boolean;
  details: boolean;
  Category;
  Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  userAdmin: boolean;
  i:any;
  overall: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  overall_result: Array<Overall_Result> = [];
  evaluate: boolean;
  report;
  college_set: College_Names={
    college_name:''
  }
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  selectedindex: any;
  selectedcollegeset: any;
  collegeid: any;
  Year: any;
  yearid: any;
  college: any;
  reportdetails: any;
  data: boolean;
  selectedyearset: any;
  year_id: any;
  qset: any;
  reportdetailss: any;
  result_details: any;
  columns: string[];
  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,private reportservice: ReportService,
              private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private fs:CollegeService,private ys:YearService,) {
  this.simpletest();

  //this.overallresult();
  this.CollegeName();
  this.getTempRowData();

  this.mobileQuery = media.matchMedia('(max-width: 600px)');
  this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.columns = this.auth.getColumnsB();
    this.showreport();
 }

simpletest() {
this.testschedulerservice.test_scheduler(this.test).subscribe(
(data) => {

this.user = sessionStorage.getItem('user');
this.fname = sessionStorage.getItem('fname');

this.lname = sessionStorage.getItem('lname');


if (this.user === '2') {

this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = true;
this.userTestTaker = true;
this.details = true;
this.overall = true;
this.questionset = true;
this.evaluate = true;
this.scheduletest = true;
// this.result = data.results;
return this.result;
} else if ( this.user === '1') {
this.userAdmin = true;
this.userSuperAdmin = true;
this.userTestScheduler = true;
this.userTestTaker = true;
this.questionset = true;
this.details = true;
this.overall = true;
this.evaluate = true;
this.scheduletest = true;
// this.result = data.results;
return this.result;
} else if ( this.user === '3') {
this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = false;
this.userTestTaker = true;
this.questionset = true;
this.details = true;
this.evaluate = true;
this.overall = true;
this.scheduletest = true;
} else if ( this.user === '4') {
this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = false;
this.userTestTaker = false;
this.questionset = false;
this.details = false;
this.scheduletest = true;
this.overall = false;
this.evaluate = false;
}
},
err => {
console.error(err);
}
);
}
getTempRowData() {
  this.newAttribute = { college_name:'', academic_year:'', questionsetname: '', pattern: '', date: '', start_time: '', end_time:'', paperlist: '', scheduler: ''};

  this.fieldArray.push(this.newAttribute);
}

// overallresult() {
//   this.qs.overall_result(this.overall_result).subscribe(
//     (data) => {
//
//       this.report = data.results;
//
//       //
//     },
//     err => {
//       console.error(err);
//     }
//   );
// }


selectChangeHandler1(event: any, i: any) {

  this.selectedindex = i;
  console.log(event.target.value)
  this.selectedcollegeset = event.target.value;

  this.collegeid = this.selectedcollegeset;
  localStorage.setItem('CollegeId', this.collegeid)
  this.ys.academicyear(this.selectedcollegeset).subscribe(
    (data) => {

      this.Year = data.results;
      this.fieldArray[i].academic_year = data.results;


      this.yearid = this.Year[0].Id
      localStorage.setItem('Yearid', this.yearid)
    },
    err => {
      console.error(err);
    }
  );
}

selectChangeHandler2(event: any, i: any) {

  this.selectedindex = i;
  console.log(event.target.value)
  this.selectedyearset = event.target.value;

  this.year_id = this.selectedyearset;
  localStorage.setItem('CollegeId', this.collegeid)
  this.question_set.collegeid = this.collegeid;
  this.question_set.yearid = this.year_id
  this.qs.college_questionset(this.question_set).subscribe(
    (data) => {

      this.result = data.results;
      this.qset = this.result[0].Id;
      localStorage.setItem('qsid', this.qset);
      //this.questionsetid=this.result[0].Id


    },
    err => {
      console.error(err);
    }
  );
}


   CollegeName() {
    this.fs.College_Name(this.college_set).subscribe(
      (data) => {

        this.college = data.results;


      },
      err => {
        console.error(err);
      }
    );
   }

     //Show Report
     showreport(){
      console.log("inside show report")
      this.data=true;
      this.report_details.College_Id=this.collegeid;
      this.report_details.Year_Id=this.yearid;
      this.report_details.Question_Set=this.qset;




      this.reportservice.candidate_report(this.report_details).subscribe(
        (data) => {

          this.result_details=data.results;
          console.log(" this.result_details", this.result_details)
          // if (data.code === 200) {
          //   alert(data.success);
          //
          // } else {
          //
          // alert(data.failed);
        //}

        this.dataSource = new MatTableDataSource( this.result_details);
        this.dataSource.sort=this.sort;

        setTimeout(() => this.dataSource.paginator = this.paginator);



        },
        err => {
          console.error(err);
        }
      );
    }


view(id) {

  this.router.navigate(['/individual_result', id]);
}
// downloadFile(data: any) {
//
//   const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
//   const header = Object.keys(data[0]);
//   let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
//   csv.unshift(header.join(','));
//   let csvArray = csv.join('\r\n');

//   var a = document.createElement('a');
//   var blob = new Blob([csvArray], {type: 'text/csv' }),
//   url = window.URL.createObjectURL(blob);

//   a.href = url;
//   a.download = "report.csv";
//   a.click();
//   window.URL.revokeObjectURL(url);
//   a.remove();
// }

downloadFile(){
 // this.data=true;
  this.report_details.College_Id=this.collegeid;
  this.report_details.Year_Id=this.yearid;
  this.report_details.Question_Set=this.qset;




  this.reportservice.download_report(this.report_details).subscribe(
    (data) => {

      this.reportdetailss=data.results;
      // if (data.code === 200) {
      //   alert(data.success);
      //
      // } else {
      //
      // alert(data.failed);
    //}

    // this.dataSource = new MatTableDataSource(this.reportdetails);
    // this.dataSource.sort=this.sort;
    // setTimeout(() => this.dataSource.paginator = this.paginator);
    //

    },
    err => {
      console.error(err);
    }
  );
}

onSearchClear() {
  this.searchKey = "";
  this.applyFilter();
}

applyFilter() {
  this.dataSource.filter = this.searchKey.trim().toLowerCase();
}
}
